import { FC, ReactNode } from "react";

import { Subheading } from "../../../typography";

import { ChatHeaderMenu } from "./ChatHeaderMenu";
import { IconButton } from "./IconButton";

import { ChatbotClassMap } from "../types";

interface Props {
  readonly styles: ChatbotClassMap;
  readonly title: ReactNode;
  readonly titleId: string;
  readonly onClear?: () => void;
  readonly onClose?: () => void;
}

/** Panel header with the branding/options mark, title, and close control. Embedded panels omit the close control. */
export const ChatHeader: FC<Props> = ({ styles, title, titleId, onClear, onClose }) => (
  <div className={styles.ChatHeaderInner}>
    <ChatHeaderMenu styles={styles} onClear={onClear} />
    <Subheading id={titleId}>{title}</Subheading>
    {!!onClose && (
      <IconButton
        icon="x-close"
        label="Close chat"
        tooltip="Close"
        onClick={onClose}
        testId="chatbot-close"
      />
    )}
  </div>
);
